import React, { useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { array, object } from 'prop-types'
import styled from 'styled-components'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'

const BrindeItem = styled.div`
  margin: 0 20px;
  text-align: center;
  width: 242px;

  @media ( max-width: 570px ){
    margin: 0 auto 40px;
  }

  @media ( min-width: 770px ) and ( max-width: 870px ){
    margin: 0 auto 40px;
  }
`

const BrindeImagemWrapper = styled.div`
  align-items: center;
  background-color: #f5f5f5;
  border: 1px solid #efefef;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  height: 220px;
  max-width: 100%;
  transition: border-color .4s ease;
  width: 100%;

  ${( { ativo, cor } ) => ativo && `box-shadow: 0px 0px 0px 2px ${cor};`}

  .imagem {
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }

  ${( { ativo, cor } ) => ativo && `border-color: ${cor};`}
`

const BrindeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 70px;
  justify-content: center;

  @media ( max-width: 570px ){
    display: block;
    margin-bottom: 30px;
  }

  .radioLabel {
      margin-bottom: 20px;

      > div {
        border-color: ${( { tema } ) => tema} !important;
        &::after {
          background: ${( { tema } ) => tema} !important;
        }
      }
    }
  #radio-brindes {
    display: flex;
    width: 100%;
    justify-content: space-around;
    input {
      padding-left: 10px;
    }
    @media (max-width: ${StyleGuide.mediaQuery.mobile}){
      label {
        width: 100%;
        text-align: center;
      }
      flex-direction: column;
    }
  }
`

const EscolhaBrinde = ( { brindes, etapaAtual } ) => {
  const { dadosEtapas, setarDadosEtapas, temaFluxo } = useFluxosPagamento()
  const [ brindeSelecionado, setBrindeSelecionado ] = useState()

  useEffect( () => {
    if ( brindes && brindes.length ) {
      const [ primeiroBrinde ] = brindes
      if ( isEmptyObject( dadosEtapas[ etapaAtual.identificador ] ) ) {
        setBrindeSelecionado( {
          'descricao': primeiroBrinde.descricao,
          'id': primeiroBrinde.id
        } )
      } else {
        setBrindeSelecionado( dadosEtapas[ etapaAtual.identificador ] )
      }
    }
  }, [] )

  useEffect( () => {
    if ( brindeSelecionado ) {
      setarDadosEtapas( brindeSelecionado, etapaAtual.identificador )
    }
  }, [ brindeSelecionado ] )

  function handleChangeRadioGroup( index ) {
    const { selectedIndex } = index
    const brinde = brindes[ selectedIndex ]
    setBrindeSelecionado( {
      'descricao': brinde.descricao,
      'id': brinde.id,
      'index': parseInt( selectedIndex, 10 )
    } )
  }

  return (
    <BrindeWrapper tema={ temaFluxo }>
      <RadioGroup
        defaultOption={ brindeSelecionado?.index || 0 }
        group="radio-brindes"
        onChange={ handleChangeRadioGroup }
      >
        { brindes.map( ( brinde, index ) => (
          <RadioButton
            group="radio-brindes"
            key={ brinde.id }
            label={ brinde.descricao }
            value={ index }
          >
            <BrindeItem
              onClick={ () => handleChangeRadioGroup( { 'selectedIndex': index } ) }
            >

              <BrindeImagemWrapper
                ativo={ dadosEtapas[ etapaAtual.identificador ] ? dadosEtapas[ etapaAtual.identificador ].id === brinde.id : null }
                cor={ temaFluxo }
              >
                <img
                  alt={ brinde.descricao }
                  className="imagem"
                  src={ brinde.imagemURL }
                />
              </BrindeImagemWrapper>
            </BrindeItem>
          </RadioButton>
        ) ) }
      </RadioGroup >
    </BrindeWrapper>
  )
}

EscolhaBrinde.propTypes = {
  'brindes': array.isRequired,
  'etapaAtual': object.isRequired
}

export default EscolhaBrinde

